<template>
  <AppLayout>
    <ContextMenu title="Configuration" />
    <v-container grid-list-md fluid pa-0>
      <v-layout row wrap>
        <v-flex xs12 sm12 md6>
          <v-toolbar color="white" flat>
            <v-toolbar-title>Fee Types</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="400px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" v-on="on">
                  <v-icon>add</v-icon>Add
                </v-btn>
              </template>
              <v-card>
                <v-card-title class="headline grey lighten-3" primary-title
                  >{{ mode }} Fee Type</v-card-title
                >
                <v-card-text>
                  <v-form ref="form" v-model="valid">
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-text-field
                            v-model="name"
                            label="Name"
                            required
                            :rules="textRules"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            v-model="comment"
                            label="Comment"
                            required
                            :rules="textRules"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-btn flat @click="reset()">Cancel</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="warning" @click="remove(id)" v-if="id">
                    <v-icon>delete</v-icon> Delete
                  </v-btn>
                  <v-btn color="primary" @click="save()">
                    <v-icon>{{ mode.toLowerCase() }}</v-icon>
                    {{ mode }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
          <v-divider />
          <v-data-table
            :headers="headers"
            :items="feeTypes"
            hide-actions
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td>{{ props.item.fee_name }}</td>
              <td>{{ props.item.fee_comment }}</td>
              <td class="justify-center">
                <v-icon
                  small
                  color="primary"
                  class="mr-2"
                  @click="edit(props.item)"
                  >edit</v-icon
                >
              </td>
            </template>
          </v-data-table>
        </v-flex>

        <v-flex xs12 sm12 md4 class="ml-3">
          <v-card>
            <v-toolbar color="white" flat>
              <v-toolbar-title>GST Option</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-divider />
            <v-card-text>
              <v-select
                v-model="gstStatus"
                :items="gstOptions"
                label="GST Option"
                item-text="text"
                item-value="value"
                class="flat"
              ></v-select>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </AppLayout>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import ContextMenu from '@/components/ContextMenu'
import AppLayout from '@/views/AppLayout'

export default {
  name: 'UserInfo',
  components: { ContextMenu, AppLayout },
  data() {
    return {
      headers: [
        { text: 'Name', value: 'fee_name' },
        { text: 'Comment', value: 'fee_comment' },
        { text: 'Actions', value: 'id', sortable: false },
      ],
      textRules: [(v) => !!v || 'This field is required'],
      id: null,
      name: null,
      comment: null,
      dialog: false,
      valid: false,
      showUpdateGstButton: true,
      gstSelected: '',
    }
  },
  computed: {
    ...mapGetters({
      feeTypes: 'Configuration/getFeeTypes',
      gstOptions: 'Configuration/getGstOptions',
    }),
    gstStatus: {
      get() {
        return this.$store.getters['Configuration/getGstStatus']
      },
      set(value) {
        this.updateAccountGstOption(value)
      },
    },
    mode() {
      return this.id ? 'Save' : 'Add'
    },
  },
  watch: {
    gstStatus: {
      handler(val, old) {
        this.gstSelected = val
      },
    },
    gstSelected: {
      handler(val, old) {
        if (typeof val === 'string') {
          self.showUpdateGstButton = true
        }
      },
    },
  },
  methods: {
    ...mapActions({
      fetch: 'Configuration/fetchFeeTypes',
      add: 'Configuration/addFeeType',
      update: 'Configuration/updateFeeType',
      remove: 'Configuration/deleteFeeType',
      getAccount: 'Configuration/getAccount',
      updateAccountGstOption: 'Configuration/updateAccountGstStatus',
    }),
    save() {
      let data = {
        fee_name: this.name,
        fee_comment: this.comment,
      }

      if (this.id) {
        data.id = this.id
        this.update(data)
      } else {
        this.add(data)
      }

      this.reset()
    },
    edit(item) {
      this.id = item.id
      this.name = item.fee_name
      this.comment = item.fee_comment
      this.dialog = true
    },
    delete(item) {
      this.$store.dispatch('Configuration/deleteFeeType', item)
    },
    reset() {
      this.id = null
      this.name = null
      this.comment = null
      this.dialog = false
    },
  },
}
</script>
